module.exports = __webpack_public_path__ + "static/media/loader.13de04a2.gif";